// vue
import mixin from './mixin.js';
if(document.querySelector('#app.js-contact')) {
	Vue.createApp({
		mixins: [mixin],
		mounted() {

		},
		methods: {
			onClickQ(e) {
				const answer = e.target.nextElementSibling
				if(answer.classList.contains('is-show')) {
					e.target.classList.remove('is-show')
					answer.classList.remove('is-show')
				} else {
					e.target.classList.add('is-show')
					answer.classList.add('is-show')
				}
			}
		}
	}).mount('#app.js-contact');
}